import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            background: 'background.light',
            pb: {base: remCalc(16), md: remCalc(24)},
            textAlign: 'center',

            '.tablet-tiles-grid-1': {
                maxW: remCalc(570),
            },
            '.desktop-tiles-grid-1': {
                maxW: remCalc(570),
            },
            '.desktop-tiles-grid-2': {
                maxW: remCalc(1140),
            },
        },
        heading: {
            textStyle: 'head-large',
            maxWidth: remCalc(1400),
            pb: {base: remCalc(16), md: remCalc(24)},
            mx: 'auto',
        },
        bodycopy: {
            textStyle: 'body-large',
            maxWidth: remCalc(1400),
            pb: {base: remCalc(16), md: remCalc(24)},
            mx: 'auto',
        },
        tiles: {
            maxWidth: remCalc(1400),
            gap: {base: remCalc(16), lg: remCalc(24)},
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'stretch',
            mx: 'auto',
        },
        tile: {
            position: 'relative',
            flexDirection: 'column',
            borderWidth: remCalc(1),
            borderColor: 'border.table',
            borderRadius: remCalc(8),
            p: {base: remCalc(16), md: remCalc(24)},
            bg: 'white',
            textAlign: 'left',
            marginTop: remCalc(46),
            active: {
                borderColor: 'background.brand',
                borderWidth: remCalc(2),
                borderTopRadius: 0,
            },
            label: {
                bg: 'background.brand',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: remCalc(46),
                top: remCalc(-46),
                left: remCalc(-2),
                width: `calc(100% + ${remCalc(4)})`,
                position: 'absolute',
                color: 'white',
                textStyle: 'body-large',
                fontWeight: 'medium',
                borderTopRadius: remCalc(8),
                borderColor: 'background.brand',
                borderWidth: remCalc(2),
            },
            title: {
                textStyle: 'head-small',
                fontWeight: 'medium',
                pb: remCalc(24),
            },
            pricecontainer: {
                justifyContent: 'flex-start',
                alignItems: 'baseline',
                flexWrap: 'wrap',
                gap: remCalc(4),
            },
            pricesfirst: {
                textStyle: 'head-xlarge',
                fontWeight: 'medium',
            },
            timing: {
                textStyle: 'head-xsmall',
                color: 'text.default',
                fontWeight: 'medium',
            },
            monthlydiscount: {
                flexDirection: 'column',
            },
            pricesrecurring: {
                pt: remCalc(8),
                textStyle: 'body-medium',
                fontWeight: 'normal',
                textDecoration: 'line-through',
                color: 'text.secondary',
            },
            addendum: {
                pt: remCalc(8),
                textStyle: 'body-medium',
                color: 'text.secondary',
            },
            image: {
                h: remCalc(200),
                mt: remCalc(24),
            },
            features: {
                listStyleType: 'none',
            },
            feature: {
                py: remCalc(16),
                pl: remCalc(24),
                position: 'relative',
                borderBottomWidth: remCalc(1),
                borderColor: 'border.table',
            },
            featurebefore: {
                content: '""',
                display: 'block',
                width: remCalc(7),
                height: remCalc(15),
                position: 'absolute',
                top: remCalc(16),
                left: remCalc(4),
                transform: 'rotate(45deg)',
                border: `${remCalc(1)} solid`,
                borderColor: 'button.background.primary-default',
                borderTop: 0,
                borderLeft: 0,
            },
            featurep: {
                textStyle: 'body-medium',
                fontWeight: 'normal',
                display: 'inline',
            },
            cta: {
                my: {base: remCalc(16), lg: remCalc(24)},
            },
            checkiconbox: {
                boxSize: {base: 'iconsSize.medium'},
                color: 'text.success',
                marginRight: remCalc(8),
            },
        },
    },
}
